import React from 'react';
import { Box, styled, Tab, useTheme } from '@mui/material';
import { CustomTabs } from 'src/frontend-common/style/common';
import Sparkles from 'src/frontend-common/components/Icons/Sparkles';

export interface InsightsCustomTabsProps {
  featureImportanceChart: number;
  setFeatureImportanceChart: React.Dispatch<React.SetStateAction<number>>;
  a11yProps: (index: number) => {
    id: string;
    'aria-controls': string;
  };
}

const InsightsCustomTabs: React.FC<InsightsCustomTabsProps> = ({ a11yProps, featureImportanceChart, setFeatureImportanceChart }) => {
  const tabs = ['Accuracy Analysis', 'Feature Importance', 'Recommendations'];
  const theme = useTheme();

  return (
    <InsightsCustomTabsWrapper
      value={featureImportanceChart}
      indicatorColor="primary"
      onChange={(e: React.SyntheticEvent, newValue: number) => setFeatureImportanceChart(newValue)}
      data-testid="insights-custom-tabs"
    >
      {tabs.map((tab, index) => (
        <Tab
          label={
            tab === 'Recommendations' ? (
              <RecommendationsTabElement component="div">
                {tab}{' '}
                <Box component="div">
                  <Sparkles stroke={featureImportanceChart !== 2 ? theme.palette.text.secondary : theme.palette.primary.main} />
                </Box>
              </RecommendationsTabElement>
            ) : (
              tab
            )
          }
          data-testid="insights-custom-tab"
          {...a11yProps(index)}
          key={tab}
        />
      ))}
    </InsightsCustomTabsWrapper>
  );
};

export default InsightsCustomTabs;

const InsightsCustomTabsWrapper = styled(CustomTabs)(({ theme }) => ({
  marginTop: theme.spacing(3.5),
  marginBottom: theme.spacing(2),
}));

const RecommendationsTabElement = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '&>div': {
    marginLeft: theme.spacing(0.5),
  },
}));
